import { useEffect } from 'react';
import { $cookie } from '@tajawal/web-core-sdk-v2/lib/services/cookie.service';
import { STORAGE_KEYS } from '@tajawal/web-core-sdk-v2/lib/constants';
import { APIError } from '@tajawal/web-core-sdk-v2/lib/utils/sentry.utils';
import type { AxiosError } from 'axios';
import useStateOfUserStatus from './useStateOfUser';
import type { Store } from '@/stores';

export default function useFetchUser({ store, isLoggedIn }: { store: Store; isLoggedIn?: boolean }): void {
  const { isCompleted, isLoading } = useStateOfUserStatus(store);
  useEffect(() => {
    function handleError(error: AxiosError) {
      // @ts-ignore
      APIError({ error, payload: { isLoggedIn }, tag: 'USER_FETCH_ERROR' });
    }
    const token = $cookie.get(STORAGE_KEYS.AUTH_TOKEN);
    if (token && !isCompleted && !isLoading) {
      store.appStore.user.fetch({ errorHandler: handleError });
    }
  }, [store, isLoggedIn]);
}
